import React, {
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useState,
  useRef,
} from "react";
import { toast } from "react-toastify";
import Table from "components/Table";
import { UserContext } from "context/user";
import Tabs from "components/organisms/Tabs";
import { getBookings } from "api/RapidEM";
import PaymentMethodCell from "../../components/PaymentMethodCell";
import OrderIDCell from "../../components/OrderIDCell";
import "./index.scss";
import BookingDatesCell from "./components/BookingDatesCell";
import BookingStatusCell from "./components/BookingStatusCell";
import BookingAddressCell from "./components/BookingAddressCell";

const RapidEMBookingsContainer = () => {
  const { token } = useContext(UserContext);
  const fetchIdRef = useRef(0);
  const [pageCount, setPageCount] = useState(0);
  const [loading, setLoading] = useState(false);
  const [bookings, setBookings] = useState([]);
  // const [status, setStatus] = useState("");

  const fetchBookings = useCallback(async () => {
    if (!token) return;

    // const orderStatus = [
    //   { status: "Booked", value: "booked" },
    //   { status: "Canceled", value: "canceled" },
    //   { status: "Paid", value: "paid" },
    //   { status: "Shipped", value: "shipped" },
    // ];
    // const filterStatus = orderStatus.find((order) => order.status === status);
    fetchIdRef.current += 1;
    const fetchId = fetchIdRef.current;
    if (fetchId === fetchIdRef.current && token) {
      setLoading(true);
      try {
        const query = "";
        const bookingData = await getBookings(query, token);
        setBookings(bookingData.data);
        setPageCount(bookingData.pages?.total_pages);
      } catch (e) {
        toast.error(e);
      }
      setLoading(false);
    }
  }, [token]);

  // const setFilter = (tab) => {
  //   setStatus(tab);
  // };

  useEffect(() => {
    fetchBookings();
  }, [fetchBookings]);

  const columns = useMemo(
    () => [
      {
        Header: "Booking ID",
        accessor: "id",
        Cell: (props) => <OrderIDCell {...props} />,
      },
      {
        Header: "Booking Dates",
        accessor: "start_date",
        Cell: (props) => <BookingDatesCell {...props} />,
      },
      {
        Header: "Address",
        accessor: "address1",
        Cell: (props) => <BookingAddressCell {...props} />,
      },
      {
        Header: "Machine",
        accessor: "machine_id",
        Cell: (props) => <PaymentMethodCell {...props} />,
      },
      {
        Header: "Status",
        accessor: "status",
        Cell: (props) => <BookingStatusCell {...props} />,
      },
    ],
    []
  );

  const tabData = [
    {
      label: "All Bookings",
      id: "all-orders",
      content: (
        <Table
          fetchData={fetchBookings}
          pageCount={pageCount}
          columns={columns}
          loading={loading}
          data={bookings}
          className="-orders-table"
        />
      ),
    },
  ];

  return (
    <div data-testid="orders-page" className="orders-page">
      <section className="header-section">
        <h1 className="title">Rapid-EM™ Booking</h1>
        <p className="description">
          In this section, you can review and manage your Rapid-EM™ Booking with
          their details. You can view or cancel your booking here.
        </p>
      </section>
      <div className="actions-wrapper">
        <Tabs tabList={tabData} />
      </div>
    </div>
  );
};

export default RapidEMBookingsContainer;
